export const DURATION_CHOICES = [
  {
    label: "5 mins",
    value: 5,
  },
  {
    label: "10 mins",
    value: 10,
  },
  {
    label: "15 mins",
    value: 15,
  },
  {
    label: "20 mins",
    value: 20,
  },
  {
    label: "25 mins",
    value: 25,
  },
  {
    label: "30 mins",
    value: 30,
  },
  {
    label: "35 mins",
    value: 35,
  },
  {
    label: "40 mins",
    value: 40,
  },
  {
    label: "45 mins",
    value: 45,
  },
];

export const PODCAST_TYPES = [{
  id: 'conversational',
  icon: 'paperflite-engage',
  value: 'Conversational',
}, {
  id: 'monologue',
  icon: 'paperflite-mic',
  value: 'Monologue',
}, {
  id: 'narrative',
  icon: 'paperflite-list-layout',
  value: 'Narrative',
}
];